export default "<div class=\"b-caller__no_res\">\n\tСовпадений нет\n</div>";